<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'competitor',
  computed: {
    typeMap() {
      return {
        CompetitorType: { name: 'Тип', method: this.CompetitorType },
        Name: { name: 'Полное имя', method: (v: any) => v, valueClass: 'text-yellow-500' },
        Gender: { name: 'Пол', method: (v: any) => v },
        HomeAway: { name: 'Сторона', method: (v: any) => (v === 'Home' ? 'Хозяева' : 'Гости') },
        SquadNumber: { name: 'Номер', method: (v: any) => v },
        FirstName: { name: 'Имя', method: (v: any) => v },
        LastName: { name: 'Фамилия', method: (v: any) => v },
      } as { [key: string]: { [valKey: string]: any } };
    },
  },
  data() {
    return {
      excludedFields: ['Competitors', 'CrestFile'],
    };
  },
  methods: {
    type(key: string) {
      return this.typeMap[key];
    },
    CompetitorType(type: string) {
      return (
        {
          NotSpecified: 'Не указано',
          Other: 'Другое',
          Person: 'Участник',
          Team: 'Команда',
          DoublesPartnership: 'Пара',
          Abstract: 'Нечто',
          Horse: 'Лошадь',
          Jockey: 'Жокей',
          Trainer: 'Тренер',
          HorseOwner: 'Владелец лошади',
          Dog: 'Собака',
        }[type] || type
      );
    },
  },
  props: ['competitor', 'root'],
});
</script>

<template>
  <span class="flex">
    <span>
      <img
        v-if="competitor.CrestFile"
        :src="`https://coins.game/assets/sport/logo/img/${competitor.CrestFile}`"
        alt="competitor crest"
        class="m-4 mr-0"
      />
    </span>
    <section
      :class="{
        'grid gap-x-2 gap-y-1 relative z-0': true,
        'grid-cols-[max-content_max-content] rounded-tl-lg rounded-tr-lg p-3': root,
        'grid-cols-[max-content_max-content]': !root,
      }"
    >
      <template
        v-for="key in Object.keys(competitor).filter((key) => !excludedFields.includes(key))"
      >
        <span>{{ type(key)?.name || key }}</span>
        <span :class="{ [type(key)?.valueClass]: true }">
          {{ type(key)?.method(competitor[key]) || competitor[key] }}
        </span>
      </template>
      <div class="hidden z">
        <pre>{{ competitor }}</pre>
      </div>
    </section>
  </span>

  <div v-if="competitor.Competitors" class="mx-0.5 my-1 grid grid-cols-4 gap-2 p-2">
    <div class="rounded-md p-4 bg-gray-700" v-for="subcompetitor in competitor.Competitors">
      <competitor :competitor="subcompetitor" />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
